import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./print.css";
import { AuthProvider } from "./context/AuthContext";
import { HelmetProvider } from "react-helmet-async";
ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <AuthProvider>
      <HelmetProvider>
      <App />
      </HelmetProvider>
    </AuthProvider>
  </BrowserRouter>
);